module.exports = __webpack_public_path__ + "img/slider-15.a173950c.jpg";